'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

var _messages = require('./messages');

var _messages2 = _interopRequireDefault(_messages);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cx = _bind2.default.bind(_style2.default);

var Fail = function Fail(_ref) {
  var onClick = _ref.onClick,
      intl = _ref.intl,
      props = _objectWithoutProperties(_ref, ['onClick', 'intl']);

  return _react2.default.createElement(
    'section',
    _extends({}, props, { className: cx('xsui-charts-description') }),
    _react2.default.createElement(
      'h2',
      null,
      intl.formatMessage(_messages2.default.fail)
    ),
    _react2.default.createElement(
      'p',
      null,
      intl.formatMessage(_messages2.default.fail_descr)
    ),
    _react2.default.createElement(
      _button2.default,
      { appearance: 'outline', onClick: onClick },
      intl.formatMessage(_messages2.default.fail_retry)
    )
  );
};

Fail.propTypes = {
  intl: function intl() {
    return (typeof IntlShape === 'function' ? _propTypes2.default.instanceOf(IntlShape).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
exports.default = (0, _reactIntl.injectIntl)(Fail);